
import { AuthPayload } from '@/interfaces/ui.interface'
import { HOST_URL_BIBI } from '@/utils/constantes';
import axios from 'axios';

export default {
  async getDashboard({ commit }: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: false
    }
    try {
      const response = await axios.get(`${HOST_URL_BIBI}/php/count/visits.json`);
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion de la DASHBOARD obtenida con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
      // commit('setGallery', response.data)
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al consultar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setDashboard', payload)
    }
  }
}
